/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Chat_EmptyInputs */

const cs_portal_chat_empty = /** @type {(inputs: Portal_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné konverzace. Makléř chat zahájí, až to bude potřeba.`)
};

const en_portal_chat_empty = /** @type {(inputs: Portal_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversations yet. Your agent will start a chat when needed.`)
};

/**
* | output |
* | --- |
* | "No conversations yet. Your agent will start a chat when needed." |
*
* @param {Portal_Chat_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_chat_empty = /** @type {((inputs?: Portal_Chat_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Chat_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_chat_empty(inputs)
	return cs_portal_chat_empty(inputs)
});